import { useGetProjectDataQuery, useGetWorkflowsQuery } from 'schema'
import { createStrictContext } from '../../utils/createContext'
import { useRouteMatches } from '../../hooks/useRouteMatches'
import { DefaultQueryHookOptions } from '../../utils/defaults'
import { ProjectContext } from './types'

const { Provider, useContextFn } =
  createStrictContext<ProjectContext>('ProjectContext')

export const useProjectContext = useContextFn

export const ProjectProvider: React.FC = ({ children }) => {
  const { param } = useRouteMatches()
  /**
   * Safe to overwrite tsc here because ProjectProvider will only wrap routes
   * that for sure have a projectId
   */
  const projectId = param('projectId')?.toLowerCase() as string

  const { data, refetch } = useGetProjectDataQuery({
    ...DefaultQueryHookOptions,
    variables: { globalId: projectId },
  })

  const { data: workflowsData, loading: workflowsLoading } =
    useGetWorkflowsQuery({
      ...DefaultQueryHookOptions,
      variables: {
        input: {
          deleted: false,
          projectId: { equals: projectId },
        },
      },
    })
  const { __typename, ...sharePoint } = data?.project?.projectMetadata ?? {}

  return (
    <Provider
      value={{
        projectId,
        projectName: data?.project?.projectName,
        sharePoint,
        workflows: workflowsData?.listWorkflows?.records ?? [],
        workflowsLoading,
        userGroups: (data?.project?.projectToUserGroups ?? []).map(
          ({ userGroup }) => ({
            id: userGroup.id,
            userIds: userGroup.users.map(({ id }) => id),
          })
        ),
        adminIds: (data?.project?.projectToCIMSOnlineAdmins ?? []).map(
          ({ userId }) => userId
        ),
        refetch,
      }}
    >
      {children}
    </Provider>
  )
}
